import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'

interface ContinueOrFreshModalProps {
  open: boolean
  onContinue: () => void
  onStartFresh: () => void
  isStartingFresh: boolean
}

/**
 * Mandatory modal shown on session re-open when last activity was 2-24h ago.
 * No Esc / click-outside dismissal — the user must pick.
 */
export function ContinueOrFreshModal({
  open,
  onContinue,
  onStartFresh,
  isStartingFresh,
}: ContinueOrFreshModalProps) {
  return (
    <Dialog open={open}>
      <DialogContent
        showCloseButton={false}
        onPointerDownOutside={(e) => e.preventDefault()}
        onEscapeKeyDown={(e) => e.preventDefault()}
      >
        <DialogHeader>
          <DialogTitle>Continue your previous session?</DialogTitle>
          <DialogDescription>
            It's been a while since you last worked on this problem. Pick up
            where you left off, or start a fresh attempt.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={onStartFresh}
            disabled={isStartingFresh}
          >
            {isStartingFresh ? 'Starting fresh...' : 'Start Fresh'}
          </Button>
          <Button onClick={onContinue} disabled={isStartingFresh}>
            Continue
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
